// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","351":"me","535":"login"}[chunkId] + "-legacy." + {"177":"f5a69ddc","351":"5792ece1","535":"052c7a04"}[chunkId] + ".js";
};